import angular from 'angular';
import { routes } from './processes.routes';
import LmeDetailProcessController from "./details/details.controller";
import LmeProcessDetailEditController from "./details/details.dialog.controller";
import LMEProcessFileUploaderController from "./details/files.dialog.controller";
import LmeDirectorySchedulingController from "./directory/directory.controller";
import LmeProcessoService from "./processos.service";
export default angular.module('app.laboratory.processes', [])
    .config(routes)
    .controller('LmeDetailProcessController', LmeDetailProcessController)
    .controller('LmeProcessDetailEditController', LmeProcessDetailEditController)
    .controller('LMEProcessFileUploaderController', LMEProcessFileUploaderController)
    .controller('LmeDirectorySchedulingController', LmeDirectorySchedulingController)
    .service('LmeProcessoService', LmeProcessoService)
    .name;
